import { API_V1 } from '../config'
import { apiFetch } from './api'

export interface PartySearchResult {
  koblink_id: string
  actor_type: 'PERSON' | 'ORGANIZATION'
  display_name: string
  email?: string | null
  organization?: { koblink_id: string; display_name: string } | null
  preferred_country?: string | null
  preferred_eid_provider?: string | null
  last_interaction_at?: string | null
  interaction_count?: number
}

/** Lightweight party search for autocomplete (min 2 chars) */
export async function searchParties(
  actorId: string,
  query: string,
  limit = 10,
): Promise<PartySearchResult[]> {
  if (query.length < 2) return []

  const params = new URLSearchParams({ q: query, limit: limit.toString() })
  const response = await apiFetch(`${API_V1}/actors/${actorId}/parties/search/?${params}`)
  if (!response.ok) {
    throw new Error(`Failed to search parties: ${response.status}`)
  }
  return response.json()
}

/** Get most recently interacted-with parties */
export async function recentParties(
  actorId: string,
  limit = 5,
): Promise<PartySearchResult[]> {
  const params = new URLSearchParams({ limit: limit.toString() })
  const response = await apiFetch(`${API_V1}/actors/${actorId}/parties/recent/?${params}`)
  if (!response.ok) {
    throw new Error(`Failed to fetch recent parties: ${response.status}`)
  }
  return response.json()
}
